export const CREDIT_MEMOS_GATE = 'commerce:invoices:creditMemos';